import BindingContext from "@odata/BindingContext";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import { withOData } from "@odata/withOData";
import { IGetDefinition } from "@pages/PageUtils";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import Page, { IProps } from "../../pages/Page";
import { getDefinitions } from "./BackgroundJobsHistory.def";
import BackgroundJobsHistoryTableView from "./BackgroundJobsHistoryTableView";

class BackgroundJobsHistory extends Page<IProps> {
    get formDefinitionFactory(): (bc: BindingContext, entityType: EntityTypeName) => Promise<IGetDefinition> {
        return async () => getDefinitions;
    }

    static defaultProps = {
        getDef: getDefinitions,
        tableView: BackgroundJobsHistoryTableView
    };
}

export default withRouter(withTranslation(["Common", "Components", "Error"])(withOData(BackgroundJobsHistory)));